export const Countries = {
    1: 'Afghanistan',
    2: 'Aland Islands',
    3: 'Albania',
    4: 'Algeria',
    5: 'American Samoa',
    6: 'Andorra',
    7: 'Angola',
    8: 'Anguilla',
    9: 'Antarctica',
    10: 'Antigua and Barbuda',
    11: 'Argentina',
    12: 'Armenia',
    13: 'Aruba',
    14: 'Ashmore and Cartier Islands',
    15: 'Australia',
    16: 'Austria',
    17: 'Azerbaijan',
    18: 'Bahamas',
    19: 'Bahrain',
    20: 'Bangladesh',
    21: 'Barbados',
    22: 'Belarus',
    23: 'Belgium',
    24: 'Belize',
    25: 'Benin',
    26: 'Bermuda',
    27: 'Bhutan',
    28: 'Bolivia',
    29: 'Bonaire, Sint Eustatius and Saba',
    30: 'Bosnia',
    31: 'Bosnia and Herzegovina',
    32: 'Botswana',
    33: 'Bouvet Island',
    34: 'Brazil',
    35: 'British Indian Ocean Territory',
    36: 'Brunei',
    37: 'Bulgaria',
    38: 'Burkina Faso',
    39: 'Burundi',
    40: 'Cambodia',
    41: 'Cameroon',
    42: 'Canada',
    43: 'Cape Verde',
    44: 'Cayman Islands',
    45: 'Central African Republic',
    46: 'Chad',
    47: 'Chile',
    48: 'China',
    49: 'Christmas Island',
    50: 'Clipperton Island',
    51: 'Cocos Island',
    52: 'Colombia',
    53: 'Comoros',
    54: 'Congo',
    55: 'Cook Islands',
    56: 'Coral Sea Islands',
    57: 'Costa Rica',
    58: 'Croatia',
    59: 'Cuba',
    60: 'Curacao',
    61: 'Cyprus',
    62: 'Czech Republic',
    63: 'DR Congo',
    64: 'Denmark',
    65: 'Djibouti',
    66: 'Dominica',
    67: 'Dominican Republic',
    68: 'Ecuador',
    69: 'Egypt',
    70: 'El Salvador',
    71: 'Equatorial Guinea',
    72: 'Eritrea',
    73: 'Estonia',
    74: 'Eswatini',
    75: 'Ethiopia',
    76: 'Falkland Islands',
    77: 'Faroe Islands',
    78: 'Fiji',
    79: 'Finland',
    80: 'France',
    81: 'French Guiana',
    82: 'French Polynesia',
    83: 'French Southern Territories',
    84: 'Gabon',
    85: 'Gambia',
    86: 'Georgia',
    87: 'Germany',
    88: 'Ghana',
    89: 'Gibraltar',
    90: 'Greece',
    91: 'Greenland',
    92: 'Grenada',
    93: 'Guadeloupe',
    94: 'Guam',
    95: 'Guatemala',
    96: 'Guernsey', 
    97: 'Guinea',
    98: 'Guinea-Bissau',
    99: 'Guyana',
    100: 'Haiti',
    101: 'Heard Island and McDonald Islands',
    102: 'High Seas',
    103: 'Honduras',
    104: 'Hong Kong',
    105: 'Hungary',
    106: 'Iceland',
    107: 'India',
    108: 'Indonesia',
    109: 'Iran',
    110: 'Iraq',
    111: 'Ireland',
    112: 'Isle of Man',
    113: 'Israel',
    114: 'Italy',
    115: "Cote d'Ivoire",
    116: 'Jamaica',
    117: 'Japan',
    118: 'Jersey',
    119: 'Jordan',
    120: 'Kazakhstan',
    121: 'Kenya',
    122: 'Kiribati',
    123: 'Kosovo',
    124: 'Kuwait',
    125: 'Kyrgyzstan',
    126: 'Laos',
    127: 'Latvia',
    128: 'Lebanon',
    129: 'Lesotho',
    130: 'Liberia',
    131: 'Libya',
    132: 'Liechtenstein',
    133: 'Lithuania',
    134: 'Luxembourg',
    135: 'Macau',
    136: 'Madagascar',
    137: 'Malawi',
    138: 'Malaysia',
    139: 'Maldives',
    140: 'Mali',
    141: 'Malta',
    142: 'Marshall Islands',
    143: 'Martinique',
    144: 'Mauritania',
    145: 'Mauritius',
    146: 'Mayotte',
    147: 'Mexico',
    148: 'Micronesia',
    149: 'Moldova',
    150: 'Monaco',
    151: 'Mongolia',
    152: 'Montenegro',
    153: 'Montserrat',
    154: 'Morocco',
    155: 'Mozambique',
    156: 'Myanmar',
    157: 'Namibia',
    158: 'Nauru',
    159: 'Nepal',
    160: 'Netherlands',
    161: 'Netherlands Antilles',
    162: 'New Caledonia',
    163: 'New Zealand',
    164: 'Nicaragua',
    165: 'Niger',
    166: 'Nigeria',
    167: 'Niue',
    168: 'Norfolk Island',
    169: 'North Korea',
    170: 'North Macedonia',
    171: 'Northern Mariana Islands',
    172: 'Norway',
    173: 'Oman',
    174: 'Pakistan',
    175: 'Palau',
    176: 'Palestine',
    177: 'Panama',
    178: 'Papua New Guinea',
    179: 'Paraguay',
    180: 'Peru',
    181: 'Philippines',
    182: 'Pitcairn',
    183: 'Poland',
    184: 'Portugal',
    185: 'Puerto Rico',
    186: 'Qatar',
    187: 'Reunion',
    188: 'Romania',
    189: 'Russia',
    190: 'Rwanda',
    191: 'Saint Barthelemy',
    192: 'Saint Helena',
    193: 'Saint Kitts and Nevis',
    194: 'Saint Lucia',
    195: 'Saint Martin',
    196: 'Saint Pierre and Miquelon',
    197: 'Saint Vincent and the Grenadines',
    198: 'Samoa',
    199: 'San Marino',
    200: 'Sao Tome and Principe',
    201: 'Saudi Arabia',
    202: 'Senegal',
    203: 'Serbia',
    204: 'Serbia and Montenegro',
    205: 'Seychelles',
    206: 'Sierra Leone',
    207: 'Singapore',
    208: 'Sint Maarten',
    209: 'Slovakia',
    210: 'Slovenia',
    211: 'Solomon Islands',
    212: 'Somalia',
    213: 'Somaliland',
    214: 'South Africa',
    215: 'South Georgia and the South Sandwich Islands',
    216: 'South Korea',
    217: 'South Sudan',
    218: 'Spain',
    219: 'Sri Lanka',
    220: 'Sudan',
    221: 'Suriname',
    222: 'Svalbard and Jan Mayen',
    223: 'Sweden',
    224: 'Switzerland',
    225: 'Syria',
    226: 'Taiwan',
    227: 'Tajikistan',
    228: 'Tanzania',
    229: 'Thailand',
    230: 'Timor Leste',
    231: 'Togo',
    232: 'Tokelau',
    233: 'Tonga',
    234: 'Trinidad and Tobago',
    235: 'Tunisia',
    236: 'Turkey',
    237: 'Turkmenistan',
    238: 'Turks & Caicos Islands',
    239: 'Tuvalu',
    240: 'U.S.A',
    241: 'Uganda',
    242: 'Ukraine',
    243: 'United Arab Emirates',
    244: 'United Kingdom',
    245: 'United States Minor Outlying Islands',
    246: 'Uruguay',
    247: 'Uzbekistan',
    248: 'Vanuatu',
    249: 'Vatican City',
    250: 'Venezuela',
    251: 'Vietnam',
    252: 'Virgin Islands, British',
    253: 'Virgin Islands, U.S.',
    254: 'Wallis & Futuna',
    255: 'Western Sahara',
    256: 'Yemen',
    257: 'Zambia',
    258: 'Zimbabwe'
};


